// The API returns full float precision so chart placement and the citationWeight >= 3 filter can
// read real values. Display rounding lives here instead.
export const formatPercentage = (value) => {
    if (value === null || value === undefined)
        return "-";
    if (typeof value === "number") {
        return `${Math.round(value)}%`;
    }
    return value;
};
export const formatGap = (value) => {
    if (value === null || value === undefined)
        return "-";
    if (typeof value === "number") {
        // Sign comes off the rounded value, so a gap of 0.4 reads "0" rather than "+0".
        const rounded = Math.round(value);
        if (rounded > 0)
            return `+${rounded}`;
        return rounded.toString();
    }
    return value;
};
export const formatCount = (value) => {
    if (typeof value === "number" && Number.isFinite(value)) {
        return Math.round(value);
    }
    return "-";
};
export const formatChangeValue = (value) => {
    if (value === null || value === undefined)
        return null;
    if (typeof value === "number") {
        if (!Number.isFinite(value))
            return null;
        return Math.round(value);
    }
    const parsed = Number.parseFloat(value);
    if (!Number.isFinite(parsed))
        return null;
    return Math.round(parsed);
};
